export default __webpack_public_path__ + "images/background-pin-white.png?8cdeec993f580db3da0ba475fb5367ca";